import type { ReactNode } from 'react';
import { Typography } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

const WidgetHeading = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SystemStyleObject;
}) => {
  return (
    <Typography
      data-testid="widget-heading"
      variant="h6"
      sx={(theme) => ({
        p: 0,
        color:
          theme.palette.mode === 'light'
            ? theme?.blox?.colors?.bluegray
            : theme?.blox?.colors?.white,
        fontWeight: 500,
        ...sx,
      })}
    >
      {children}
    </Typography>
  );
};

export default WidgetHeading;
